import * as Sentry from '@sentry/react';

const SENTRY_DSN =
    'https://1b825051d03f9a811dca39f62892197f@o4510209831927808.ingest.us.sentry.io/4510209851654144';

export function initSentry(): void {
    const nodeEnv = process.env.NODE_ENV;

    // Don't initialize Sentry in development mode
    // In development, NODE_ENV is either undefined or 'development'
    if (!nodeEnv || nodeEnv === 'development') {
        console.info('[Sentry] Skipping initialization in development mode');
        return;
    }

    // Determine environment: 'staging' or 'production'
    const environment = nodeEnv === 'production' ? 'production' : 'staging';
    const release = process.env.VITE_SENTRY_RELEASE || 'development';

    if (!SENTRY_DSN) {
        console.warn('[Sentry] No DSN provided, skipping initialization');
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        environment,
        release,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
        // Session Replay
        replaysSessionSampleRate: 0.1, // Sample 10% of sessions
        replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    });
}
